import { progress } from '../../variables/services';

export  const fetch_task = async (taskId, setTask) => { 
        try {
            const queryParams = new URLSearchParams({task_id: taskId}).toString();
            const res = await fetch(`${progress}/task?${queryParams}`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if (!res.ok) {
                const data = await res.json();
            }

            const data = await res.json();
            setTask(data);
            return data; // <-- now fetch_task actually returns data
        } catch (error) {
            console.error("Error fetching task: ", error);
        }
    }
